<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center py-10>
      <v-flex xs12 sm10>
        <v-card>
          <v-layout wrap justify-center py-5>
            <v-flex xs11 sm10>
              <v-layout wrap>
                <v-flex xs12 text-center>
                  <span class="itemHeading">LEAVE FORM</span>
                </v-flex>
              </v-layout>
              <v-layout wrap pt-5>
                <v-flex>
                  <span class="itemHeading2">
                    Total Leaves: {{ totalLeaves }}</span>
                </v-flex>
                <v-flex>
                  <span class="itemHeading2">
                    Leaves Taken: {{ leavesTaken }}</span>
                </v-flex>
                <v-flex>
                  <v-dialog v-model="dialogDetails" max-width="80%">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small v-on="on" v-bind="attrs" color="#005f32" dark><span
                          style="font-family: kumbhRegular">Leave Details</span></v-btn>
                    </template>
                    <v-card>
                      <v-layout wrap>
                        <v-flex xs12 align-self-center pa-4 style="background: #005f32" text-left>
                          <span class="kumbhBold" style="color: #ffffff">LEAVE DETAILS</span>
                        </v-flex>
                        <v-flex xs12 align-self-center class="kumbhBold">
                          <v-layout wrap pa-4>
                            <v-flex xs12 sm12 v-for="info in leaveCategories" :key="info._id">
                              <v-layout wrap>
                                <v-flex xs12 sm6 md3>
                                  <v-layout wrap>
                                    <v-flex xs12>
                                      <span style="color: #005f32">Category</span>
                                    </v-flex>
                                    <v-flex xs12>
                                      <span>{{ info.leaveCategory }}</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-layout wrap>
                                    <v-flex xs12>
                                      <span style="color: #005f32">Total Leaves</span>
                                    </v-flex>
                                    <v-flex xs12>
                                      <span>{{ info.totalLeaves }}</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm6 md3>
                                  <v-layout wrap>
                                    <v-flex xs12>
                                      <span style="color: #005f32">Balance Leave</span>
                                    </v-flex>
                                    <v-flex xs12>
                                      <span>{{ info.totalLeaves - info.availedLeaves }}</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm6 md3>
                                  <v-layout wrap>
                                    <v-flex xs12>
                                      <span style="color: #005f32">Leaves Taken</span>
                                    </v-flex>
                                    <v-flex xs12>
                                      <span>{{ info.availedLeaves }}</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-dialog>
                </v-flex>
                <v-flex>
                  <v-dialog v-model="dialogFestival" max-width="80%">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small v-on="on" v-bind="attrs" color="#005f32" dark>
                        <span style="font-family: kumbhRegular">Festival Leaves</span>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-layout wrap>
                        <v-flex xs12 align-self-center pa-4 style="background: #005f32" text-left>
                          <span class="kumbhBold" style="color: #ffffff">FESTIVAL LEAVES</span>
                        </v-flex>
                        <v-flex xs12 align-self-center pl-8 pt-4 text-left>
                          <div style="display: flex; align-items: center; gap: 16px; font-size: 16px;">
                            <!-- Green Dot for Office Open -->
                            <span style="display: flex; align-items: center;">
                              <span style="
                                  height: 10px;
                                  width: 10px;
                                  background-color: #28a745;
                                  border-radius: 50%;
                                  display: inline-block;
                                  margin-right: 8px;
                                "></span>
                              <span class="kumbhBold">Office Open</span>
                            </span>

                            <!-- Red Dot for Office Closed -->
                            <span style="display: flex; align-items: center;">
                              <span style="
                                  height: 10px;
                                  width: 10px;
                                  background-color: red;
                                  border-radius: 50%;
                                  display: inline-block;
                                  margin-right: 8px;
                                "></span>
                              <span class="kumbhBold">Office Closed</span>
                            </span>
                          </div>
                        </v-flex>

                        <v-flex xs12 pb-4 align-self-center class="kumbhBold">
                          <v-sheet height="64">
                            <v-toolbar flat>
                              <v-btn fab text small color="grey darken-2" @click="prev">
                                <v-icon small>mdi-chevron-left</v-icon>
                              </v-btn>
                              <v-btn fab text small color="grey darken-2" @click="next">
                                <v-icon small>mdi-chevron-right</v-icon>
                              </v-btn>
                              <v-toolbar-title>
                                {{ monthYearTitle }}
                              </v-toolbar-title>
                            </v-toolbar>
                          </v-sheet>
                          <v-sheet height="600">
                            <v-calendar ref="calendar" v-model="focus" color="success" :events="events" :type="type"
                              @input="updateYear" />
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center pt-5>
                <v-flex xs12 text-left>
                  <span class="itemText2">Apply leave for</span>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap pt-5 class="itemText2">
                    <v-flex xs2 sm2>
                      <v-checkbox id="me" v-model="appliedBy" label="Me" value="me"></v-checkbox>
                    </v-flex>
                    <!-- Already commented:Leave marking for team member -->
                    <!-- <v-flex xs2 sm2>
                      <v-checkbox id="others" v-model="appliedBy" label="Others" value="others"></v-checkbox>
                    </v-flex> -->
                    <v-flex xs2 sm2 v-if="userId && userId === '62a30b37d75aa11a84de313e'">
                      <v-checkbox id="others" v-model="appliedBy" label="Employee" value="others"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- Already commented:Leave marking for team member -->
                <!-- <v-flex xs12 sm12 text-left v-if="appliedBy == 'others'">
                  <span class="itemText2">Please Select a team Member</span>
                  <v-autocomplete v-model="uid" :items="teamMembers" dense outlined :search-input.sync="search"
                    item-text="name" item-value="_id"></v-autocomplete>
                </v-flex> -->
                <v-flex xs12 sm12 text-left v-if="appliedBy == 'others'">
                  <span class="itemText2">Please select an employee</span>
                  <v-autocomplete v-model="uid" :items="teamMembers" dense outlined :search-input.sync="search"
                    item-text="name" item-value="_id"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 text-left pr-2 pl-0 pl-xs-0 pl-sm-2 pl-md-2 pl-lg-0 pl-xl-0>
                  <span class="itemText2">Category</span>
                  <v-select v-model="leaveCategory" :items="leaveCategories" item-text="leaveCategory"
                    item-value="leaveCategory" dense outlined></v-select>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 text-left pr-0 pr-xs-0 pr-sm-0 pr-md-2 pr-lg-0 pr-xl-0>
                  <span class="itemText2">Type</span>
                  <v-select v-model="leaveType" :items="leaveTypes" item-text="name" item-value="value" dense
                    outlined></v-select>
                </v-flex>

                <!-- Updated Leave Dates section with From and To fields -->
                <v-flex xs12 text-left>
                  <span class="itemText2">Leave Dates</span>
                  <v-layout wrap>
                    <v-flex xs12 sm6 pr-2 pl-0 pl-xs-0 pl-sm-2 pl-md-2 pl-lg-0 pl-xl-0>
                      <span class="itemText2">From</span>
                      <v-menu v-model="fromMenu" :close-on-content-click="false" transition="scale-transition" offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field outlined v-model="formattedFrom" label="From Date" append-icon="mdi-calendar"
                            readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="fromDate" no-title scrollable @input="fromMenu = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 pr-0 pr-xs-0 pr-sm-0 pr-md-2 pr-lg-0 pr-xl-0>
                      <span class="itemText2">To</span>
                      <v-menu v-model="toMenu" :close-on-content-click="false" transition="scale-transition" offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field outlined v-model="formattedTo" label="To Date" append-icon="mdi-calendar"
                            readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="toDate" no-title scrollable @input="toMenu = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <!-- Display selected dates as removable chips -->
                  <v-combobox v-model="formattedDates" :items="[]" multiple chips small-chips dense outlined readonly
                    hide-no-data class="mt-4">
                    <template v-slot:selection="{ item, index }">
                      <v-chip class="my-1" v-if="item" small close @click:close="removeDate(index)" outlined>
                        {{ item }}
                      </v-chip>
                    </template>
                  </v-combobox>

                  <v-btn v-if="dateArray.length" text color="red" @click="clearDates" class="mt-2">
                    Delete All
                  </v-btn>
                </v-flex>
                <v-flex xs12 text-left class="mt-2">
                  <span class="itemText2 mb-2 d-block">Supporting Document (Optional)</span>

                  <v-sheet rounded="lg" class="pa-4 text-center" color="grey lighten-4"
                    style="border: 2px dashed #005f32; position: relative;">
                    <v-layout column align-center justify-center>
                      <v-icon size="40" color="#005f32">mdi-cloud-upload-outline</v-icon>

                      <div v-if="!docuploaded" class="mt-2">
                        <v-btn text color="#005f32" class="kumbhBold capitalize"
                          @click="$refs.fileInput.$refs.input.click()">
                          <span class="kumbhBold" style="color:#005f32; font-size:16px; text-transform: capitalize;">
                            Click to upload
                          </span> </v-btn>
                        <span class="hidden-xs-only">or drag and drop</span>
                        <div class="caption grey--text">PDF, DOC, or DOCX</div>
                      </div>

                      <v-layout v-else align-center justify-center class="mt-2">
                        <v-chip color="#005f32" dark label close @click:close="docuploaded = null">
                          <v-icon left small>mdi-file-document-outline</v-icon>
                          {{ docuploaded.name }}
                        </v-chip>
                      </v-layout>
                    </v-layout>

                    <v-file-input ref="fileInput" v-model="docuploaded" accept=".pdf,.doc,.docx" style="display: none;"
                      prepend-icon="" hide-details></v-file-input>
                  </v-sheet>

                  <v-messages :value="[fileValidation(docuploaded)]" color="error"
                    v-if="docuploaded && fileValidation(docuploaded) !== true"></v-messages>
                </v-flex>
                <v-flex xs12 text-left class="mt-6">
                  <span class="itemText2">Reason for Leave</span>
                  <v-textarea class="mt-2" v-model="reason" outlined></v-textarea>
                </v-flex>
                <v-flex xs12 py-5>
                  <v-btn color="#005f32" dark @click="validateInput()"><span
                      style="font-family: kumbhRegular">Submit</span></v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      festivalDates: [],
      holidays: [],
      holidayMap: {},
      dialogFestival: false,
      selectedYear: new Date().getFullYear(),
      visible: false,
      multi: true,
      showsnackbar: false,
      orgId: localStorage.getItem("orgid"),
      userId: localStorage.getItem("userid"),

      appliedBy: "me",
      uid: null,
      docuploaded: null,
      search: "",
      value: "",
      empID: "",
      fullName: "",
      email: "",
      phone: "",
      message: "",
      msg: "",
      leaveType: "Fullday",
      totalLeaves: null,
      leavesTaken: 0,
      leaveRequiredOn: "",
      leaveCategory: "",
      reason: "",
      leaveCategories: [],
      leaveTypes: [{ name: "Full Day", value: "Fullday" }, { name: "First Half", value: "FN" }, { name: "Second Half", value: "AN" }],
      isDateCorrect: true,

      teamMembers: [],
      focus: new Date().toISOString().substr(0, 10), // Set to current date

      dialogDetails: false,
      monthYearTitle: "",
      type: 'month', // Calendar view type
      dateArray: [],
      formattedDates: '',

      // New fields for From/To dates
      fromDate: null,
      toDate: null,
      fromMenu: false,
      toMenu: false,
      formattedFrom: '',
      formattedTo: ''
    };
  },
  computed: {
    events() {
      return this.holidays.map((festival) => ({
        start: festival.festivalDate.slice(0, 10),
        end: festival.festivalDate.slice(0, 10),
        name: `${festival.festivalName} (${festival.isOfficeOpen ? "Office Open" : "Office Closed"})`,
        color: festival.isOfficeOpen ? "#28a745" : "#d9534f", // Green for open, red for closed
      }));
    },
  },

  watch: {
    fromDate(val) {
      this.formattedFrom = val ? this.formatDate(val) : '';
      this.generateDates();
    },
    toDate(val) {
      this.formattedTo = val ? this.formatDate(val) : '';
      this.generateDates();
    },
    uid() {
      this.getleaves();
    },
    appliedBy() {
      if (this.appliedBy == "me") {
        this.uid = ""
      }
      if (this.appliedBy == "others") {
        this.leavesTaken = 0;
      }
      else { this.leavesTaken = 0; }
    },
    search(val) {
      this.loading = true;
      setTimeout(() => {
        this.getEmployeeList(val);
        this.loading = false;
      }, 500);
    },
    leaveCategory() {
      this.clearDates();
      this.fromDate = null;
      this.toDate = null;
      this.formattedFrom = '';
      this.formattedTo = '';
    },
  },
  mounted() {
    this.getleaves();
    this.getEmployeeList();
    this.updateYear();
  },
  methods: {
    generateDates() {
      if (this.fromDate && this.toDate) {
        let start = this.fromDate;
        let end = this.toDate;
        if (new Date(start) > new Date(end)) {
          [start, end] = [end, start];
        }
        this.dateArray = this.getDatesInRange(start, end);
        this.formattedDates = this.dateArray.map(date => this.formatDate(date));
      } else {
        this.dateArray = [];
        this.formattedDates = [];
      }
    },
    getDatesInRange(start, end) {
      let dateArray = [];
      let currentDate = new Date(start);
      let stopDate = new Date(end);

      while (currentDate <= stopDate) {
        const dayOfWeek = currentDate.getDay();
        // 0 = Sunday, 6 = Saturday
        // Only push if it's NOT Sunday (0) and NOT Saturday (6)
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          dateArray.push(currentDate.toISOString().split("T")[0]);
        }

        // Move to next day
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dateArray;
    },
    removeDate(index) {
      // Remove the selected date from dateArray
      this.dateArray.splice(index, 1);

      // Update formattedDates to reflect the removal
      this.formattedDates = this.dateArray.map(date => this.formatDate(date));
    },
    // clearDates() {
    //   this.dateArray = [];
    //   this.formattedDates = [];
    // },
    clearDates() {
      this.dateArray = [];
      this.formattedDates = [];
      this.fromDate = null;
      this.toDate = null;
      this.formattedFrom = '';
      this.formattedTo = '';
    },
    clearFile(event) {
      if (event) event.stopPropagation();
      this.docuploaded = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
    },
    prev() {
      this.$refs.calendar.prev();
      this.updateYear();
    },
    // Move to the next period
    next() {
      this.$refs.calendar.next();
      this.updateYear();
    },
    fetchHolidays(year) {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/festival/getalllist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { year },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.holidays = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.error(err);
        });
    },
    updateYear() {
      const selectedDate = new Date(this.focus);
      const year = selectedDate.getFullYear();
      const month = selectedDate.toLocaleString("default", { month: "long" });
      this.monthYearTitle = `${month} ${year}`; // Update month and year title
      this.fetchHolidays(year); // Fetch holidays for the selected year
    },

    formatDate(date) {
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')  // Ensure two digits
      const month = String(d.getMonth() + 1).padStart(2, '0') // Months are zero-based
      const year = d.getFullYear()

      return `${day}-${month}-${year}` // Format as dd-mm-yyyy
    },
    // View day details when clicked

    createHolidayMap() {
      this.holidayMap = this.holidays.reduce((map, festivalDay) => {
        const dateStr = festivalDay.festivalDate.slice(0, 10); // Format as YYYY-MM-DD
        if (!map[dateStr]) {
          map[dateStr] = [];
        }
        map[dateStr].push(festivalDay);
        return map;
      }, {});
    },
    fileValidation(file) {
      if (!file) return true; // Optional: return true if no file is selected

      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ];

      const isCorrectType = allowedTypes.includes(file.type);
      return isCorrectType || 'Only PDF or Word documents are allowed';
    },
    validateInput() {
      const requestedDays = this.dateArray.length;
      const availableDays = this.totalLeaves - this.leavesTaken;
      if (this.appliedBy == 'others') {
        if (!this.uid) {
          this.msg = "Please select an employee";
          this.showsnackbar = true;
          return;
        }
      }
      if (this.docuploaded && this.fileValidation(this.docuploaded) !== true) {
        this.msg = "Please upload a valid PDF or Word document";
        this.showsnackbar = true;
        return;
      }
      if (requestedDays > availableDays) {
        this.msg = `You only have ${availableDays} day(s) available, but you selected ${requestedDays} weekday(s).`;
        this.showsnackbar = true;
        return;
      }
      if (!this.dateArray.length > 0) {
        this.msg = "Please select date";
        this.showsnackbar = true;
        return;
      } else if (!this.leaveType) {
        this.msg = "Please select leave type";
        this.showsnackbar = true;
        return;
      } else if (!this.leaveCategory) {
        this.msg = "Please select category";
        this.showsnackbar = true;
        return;
      }
      else if (!this.reason) {
        this.msg = "Please provide reason";
        this.showsnackbar = true;
        return;
      } else {
        // Everything is valid
        this.applyLeave();
      }
    },
    // validateInput() {

    //   if (this.appliedBy == 'others') {
    //     if (!this.uid) {
    //       // this.msg = "Please select team member";
    //       this.msg = "Please select an employee";
    //       this.showsnackbar = true;
    //       return;
    //     }
    //     else {
    //       this.applyLeave();
    //     }
    //   }
    //   else if (!this.dateArray.length > 0) {
    //     this.msg = "Please select date";
    //     this.showsnackbar = true;
    //     return;
    //   } else if (!this.leaveType) {
    //     this.msg = "Please select leave type";
    //     this.showsnackbar = true;
    //     return;
    //   } else if (!this.leaveCategory) {
    //     this.msg = "Please select category";
    //     this.showsnackbar = true;
    //     return;
    //   } else if (!this.reason) {
    //     this.msg = "Please provide reason";
    //     this.showsnackbar = true;
    //     return;
    //   } else {
    //     this.applyLeave();
    //   }
    // },
    getleaves() {
      this.visible = true;
      // var data1 = {};
      // data1["orgId"] = this.orgId;
      var id;
      if (this.appliedBy == "me") {
        id = this.userId;
        this.uid = "";
      }
      else if (this.appliedBy == "others") id = this.uid;

      axios({
        method: "POST",
        url: "/employee/leave/details/view/" + id,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.visible = false;
            this.leaveCategories = response.data.data.leaveDetails;
            this.leaveCategory = this.leaveCategories[0].leaveCategory;
            this.totalLeaves = response.data.totalAllowedLeaves;
            this.leavesTaken = response.data.totalAvailedLeaves;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    getEmployeeList(val) {
      this.visible = true;
      axios({
        method: "GET",
        url: "/employee/attendance/mark/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // empId: this.userId,
          searchKeyword: val,
        },
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.visible = false;
            this.teamMembers = response.data.data;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    applyLeave() {
      this.visible = true; // Setting loading state
      let formData = new FormData();
      let dateArray = this.dateArray.map(date => new Date(date).toISOString());

      // Append your existing data points
      formData.append("reason", this.reason);
      formData.append("leaveType", this.leaveType);
      formData.append("leaveCategory", this.leaveCategory);

      // When sending arrays in FormData, we loop and append or stringify
      // Most backends prefer the stringified version for arrays in multipart
      formData.append("leaveRequiredOn", JSON.stringify(dateArray));

      if (this.appliedBy === "others") {
        formData.append("uid", this.uid);
      }

      // Pass the optional file
      if (this.docuploaded) {
        formData.append("docuploaded", this.docuploaded);
      }

      let url = this.appliedBy === "me" ? "/employee/apply/leave/v1" : "/admin/apply/another/employee/leave";

      if (this.isDateCorrect) {
        axios.post(url, formData, {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
            "Content-Type": "multipart/form-data"
          }
        })
          .then(response => {
            this.visible = false;
            this.status = response.data.status;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            if (response.data.status) this.$router.push({ name: "myLeaves" });
          })
          .catch(err => {
            this.visible = false;
            this.msg = err.response?.data?.status === false ? "Please Try Again" : "An error occurred.";
            this.showsnackbar = true;
          });
      } else {
        this.visible = false;
        this.msg = `You can only select ${this.totalLeaves - this.leavesTaken} number of day(s)`;
        this.showsnackbar = true;
      }
    }
    // applyLeave() {
    //   let data1 = {};
    //   let dateArray = this.dateArray.map(date => new Date(date).toISOString()); // Always use the final dateArray (expanded and pruned)

    //   data1["reason"] = this.reason;
    //   data1["leaveType"] = this.leaveType;
    //   data1["leaveCategory"] = this.leaveCategory;
    //   data1["leaveRequiredOn"] = dateArray;

    //   if (this.appliedBy === "others") {
    //     data1["uid"] = this.uid;
    //   }

    //   let url = this.appliedBy === "me" ? "/employee/apply/leave/v1" : "/admin/apply/another/employee/leave";

    //   if (this.isDateCorrect) {
    //     axios.post(url, data1, { headers: { "x-auth-token": localStorage.getItem("token") } })
    //       .then(response => {
    //         this.visible = false;
    //         this.status = response.data.status;
    //         this.msg = response.data.msg;
    //         this.showsnackbar = true;
    //         if (response.data.status) this.$router.push({ name: "myLeaves" });
    //       })
    //       .catch(err => {
    //         this.visible = false;
    //         this.msg = err.response?.data?.status === false ? "Please Try Again" : "An error occurred.";
    //         this.showsnackbar = true;
    //       });
    //   } else {
    //     this.msg = `You can only select ${this.totalLeaves - this.leavesTaken} number of day(s)`;
    //     this.showsnackbar = true;
    //   }
    // }
  },
};
</script>